// Employee/styles/DayViewStyles.ts
import {Theme} from "@mui/material/styles";

export const styles = (theme: Theme) => ({
    wrapper: {
        display: "flex",
        flexDirection: "column",
        backgroundColor: "transparent",
        color: theme.palette.text.primary,
        height: "100%",
        width: "100%",
        overflowY: "auto",
        [theme.breakpoints.down("sm")]: {
            fontSize: "0.75rem",
        },
    },
    timeSlot: {
        color: theme.palette.text.secondary,
        fontSize: "0.75rem",
        fontWeight: "bold",
        textAlign: "left",
        padding: theme.spacing(0.5),
        width: "auto",
        minWidth: "60px",
        userSelect: "none",
        position: "sticky",
        left: 0,
        backgroundColor: "transparent",
        borderBottom: `1px solid ${theme.palette.divider}`,
        zIndex: 2,
        [theme.breakpoints.down("sm")]: {
            minWidth: "40px",
            fontSize: "0.625rem",
            padding: theme.spacing(0.2),
        },
    },
    tableContainer: {
        flexGrow: 1,
        overflowX: "auto",
        height: "100%",
        overflowY: "auto",
        scrollbarWidth: "thin",
        scrollbarColor: `${theme.palette.grey[400]} transparent`,
    },
    table: {
        borderCollapse: "collapse",
        width: "100%",
        tableLayout: "fixed",
    },
    tableBody: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "10vh",
    },
    tableRow: {
        display: "flex",
        width: "100%",
    },
    dayColumn: {
        flex: 1,
        backgroundColor: "transparent",
        borderBottom: `1px solid ${theme.palette.divider}`,
        position: "relative",
        padding: 0,
        overflow: "visible",
        userSelect: "none",
        transition: "background-color 0.2s ease",
    },
    eventCard: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        boxShadow: "none",
        borderRadius: theme.shape.borderRadius,
        padding: 0,
        paddingLeft: "5px",
        height: "100%",
        zIndex: 10,
        userSelect: "none",
        overflow: "hidden",
        textOverflow: "ellipsis",
        fontSize: "0.8rem",
        cursor: "pointer",
        backgroundColor: theme.palette.grey[200],
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "center",
        },
    },
    eventCardText: {
        display: "flex",
        gap: 0.5,
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
        },
    },
    eventTitle: {
        fontWeight: "bold",
        fontSize: "0.9rem",
        lineHeight: 1.2,
        [theme.breakpoints.down("sm")]: {
            fontSize: "0.75rem",
        },
    },
    eventTime: {
        fontSize: "0.75rem",
        color: theme.palette.text.secondary,
        [theme.breakpoints.down("sm")]: {
            fontSize: "0.65rem",
        },
    },
});
